<style>
#race input[type=checkbox] {
    text-indent: 0;
    margin-left: 0;
}

#race label {
    color: #495057;
    display: inline-block;
    text-indent: -2.1rem;
    margin-left: 2.1rem;
    font-weight: 400;
}

#race label::first-line {
    text-indent: 0;
    margin-left: 0;
}

#race .dont-indent-checkbox-group {
    text-indent: 0;
    margin-left: -0.45rem;
}

#race .checkbox-caret {
    text-indent: 0;
    font-weight: bold;
}

#race .group-background {
    background: #E2E6ED80 0 0 no-repeat padding-box;
    opacity: 1;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
}
</style>

<template>
    <div>
        <div v-if="show"
             id="modal-demographic"
             class="modal d-block"
             tabindex="-1"
             role="dialog"
             style="overflow-y: auto;"
        >
            <div class="modal-dialog" style="margin: 2rem auto;" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" style="text-transform: none;">Demographic Information</h5>
                        <button v-if="false" type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" id="demographic_info">
                        <div class="mb-4">
                            Please complete this form and save changes to close.
                        </div>
                        <div class="alert alert-danger" v-if="updateerror">
                            {{this.updateerror}}
                        </div>


                        <label for="race">Race (select up to three) <span class="text-danger small-hint">*</span></label>
                        <div id="race" class="card card-body" style="border-radius: 5px">
                            <template v-for="(option, subCategoryName) in race">
                                <label v-if="isToggleableSubCategory(subCategoryName)" :for="subCategoryName" class="d-flex justify-content-between" style="margin-left: 2.04em;">
                                     <span>
                                         <input type="checkbox" :id="subCategoryName" :value="subCategoryName" v-model="visibleSubCategories" class="mr-2">
                                         {{ subCategoryName }}
                                     </span>
                                    <span class="d-flex justify-content-end align-items-center">
                                         <i class="bi bi-chevron-down checkbox-caret" v-if="!isSubCategoryVisible(subCategoryName)"></i>
                                         <i class="bi bi-chevron-up checkbox-caret" v-if="isSubCategoryVisible(subCategoryName)"></i>
                                     </span>
                                </label>

                                <div v-show="isSubCategoryVisible(subCategoryName) || !subCategoryName"
                                     :key="subCategoryName"
                                     :class="{'dont-indent-checkbox-group': !isToggleableSubCategory(subCategoryName), 'group-background': isToggleableSubCategory(subCategoryName)}"
                                >
                                    <div v-for="(raceName, raceId) in option" :key="raceId">
                                        <label :for="raceId" style="font-weight: 400;">
                                            <input
                                                type="checkbox"
                                                :id="raceId"
                                                :value="raceId"
                                                v-model="userrace"
                                                class="mr-2 ml-2"
                                            />
                                            {{ raceName }}
                                        </label>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <div name="user_race_id"></div>

                        <label class="mt-3" for="ethnicity">Ethnicity <span class="text-danger small-hint">*</span></label>
                        <select id="ethnicity" name="user_ethnicity_id" type="text" v-model="userethnicity" class="form-control">
                            <option value="">Please Select</option>
                            <template v-for="(option, index) in ethnicity">
                                <template v-if="index">
                                    <optgroup :label="index" >
                                        <option v-for="(value,key) in option" :value="key">{{value}}</option>
                                    </optgroup>
                                </template>
                                <template v-else>
                                    <option v-for="(value,key) in option" v-if="value!='Prefer Not to Answer'" :value="key">{{value}}</option>
                                </template>
                            </template>
                            <option value="1">Prefer Not to Answer</option>
                        </select>

                        <label class="mt-4" for="pronouns">Personal Pronouns <span class="text-danger small-hint">*</span></label>
                        <select id="pronouns" type="text" v-model="userpronouns" class="form-control">
                            <option value="">Please Select</option>
                            <option v-for="(value,key) in pronouns" :value="key">{{ value }}</option>
                        </select>
                        <template v-if="userpronouns=='Other'">
                            <label class="mt-4" for="pronouns_other">Please Specify <span class="text-danger small-hint">*</span></label>
                            <input id="pronouns_other" name="pronouns_other" type="text" v-model="userpronouns_other" maxlength="30" class="form-control">
                        </template>
                        <p name="pronouns"></p>
                        <span class="text-danger">* Required fields</span>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="save()">Save Changes</button>
                        <button v-if="false" type="button" class="btn btn-primary" data-dismiss="modal" @click="close()">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="show" class="modal-backdrop show"></div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
    name: "ModalDemographic",
    props: [
        'user',
        'ethnicity',
        'race'
    ],
    data() {
        return {
            updateerror:false,
            userrace: [],
            userethnicity: '',
            userpronouns: '',
            userpronouns_other: '',
            pronouns:{
                'Prefer Not to Answer':'Prefer Not to Answer',
                'He/Him':'He/Him',
                'She/Her':'She/Her',
                'They/Them':'They/Them',
                'Other':'Other',
            },
            visibleSubCategories: []
        }
    },
    computed: {
        show() {
            return this.$store.state.user.showModalDemographic && (!this.user.pronouns || !this.user.user_ethnicity_id || !this.user.user_race_id);
        }
    },
    mounted() {
        if (!this.show) {
            $('.modal-card').modal({
                show: true,
            });
        }
        this.user.pronouns=this.user.pronouns!==null?this.user.pronouns:'';
        this.userethnicity=this.user.user_ethnicity_id!== null?this.user.user_ethnicity_id:'';
        this.userrace = this.user.user_race_id !== null
            ? this.user.user_race_id.map(String)
            : [];

        this.userpronouns = Object.keys(this.pronouns).includes(this.user.pronouns) || this.user.pronouns === ''
            ? this.user.pronouns
            : 'Other';

        for (const subCategoryName in this.race) {
            let show = false;

            // If a users selected race option is contained within the subCategory, make show true.
            for (const raceId of this.userrace) {
                if (this.race[subCategoryName][raceId]) {
                    show = true;
                    break;
                }
            }

            if (show) {
                this.visibleSubCategories.push(subCategoryName);
            }
        }
        this.visibleSubCategories.push('zzLast');
    },

    watch: {
        userrace(newValue) {
            console.log(newValue);
            // When 'Prefer not to answer' (value of "1") is selected, unselect the other options.
            if (newValue.length > 1 && newValue[newValue.length - 1] === "1") {
                this.$nextTick(function () {
                    // Vue2 reactivity hackery by using set and splice
                    this.$set(this.userrace, 0, '1')
                    this.userrace.splice(1);

                    // Close all toggles
                    this.visibleSubCategories = ["", "zzLast"]
                });
            } else if (newValue.includes("1") && newValue.length > 1) {
                // When 'Prefer not to answer' (value of "1") was selected, and another option has now been added,
                // unselect 'Prefer not to answer'
                const index = newValue.indexOf("1");
                this.$nextTick(function () {
                    this.userrace.splice(index, 1);
                });
            } else if (newValue.length === 1 && newValue[0] === "1") {
                // This solves an edge case that when a sub category is open, no inputs have been selected and then
                // 'Prefer not to answer' is selected, the sub categories should close.
                this.$nextTick(function () {
                    // Close all toggles
                    this.visibleSubCategories = ["", "zzLast"]
                });
            }
        }
    },

    methods: {
        isToggleableSubCategory(subCategoryName) {
            let nonToggleable = subCategoryName === '' || subCategoryName === 'zzLast'
            return ! nonToggleable;
        },
        isSubCategoryVisible(subCategoryName) {
            return this.visibleSubCategories.includes(subCategoryName);
        },
        findKey(arr, key){
            return _.find(_.map(arr, (item, index) => item ==key ? index : null),_.isNumb)
        },
        ...mapActions('user', ['demographicModalOff']),
        close() {
            this.demographicModalOff();
            $('.modal-card').modal('toggle');
        },
        save() {
            this.$http.put(`/api/users-demographic-modal`, {
                pronouns: this.userpronouns,
                pronouns_other: this.userpronouns === 'Other'
                    ? this.userpronouns_other
                    : null,
                user_race_id: this.userrace,
                user_ethnicity_id: this.userethnicity
            }).then(function(response) {
                if (response.data.Status){
                    this.updateerror=false;
                    this.close();
                }else{
                    this.updateerror=response.data.Message;
                }
            }, (response) => {
                this._handleErrors(response.data, '#demographic_info')
            });
        },
        _handleErrors: function(items, selector) {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="'+name+'"]')
                    el.closest('.form-group').addClass('has-error')

                    if (error === 'user_race_id') {
                        $('<p class="help-block" style="margin-top: 0px;">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                    } else if (error === 'user_ethnicity_id' || error === 'pronouns_other') {
                        $('<p class="help-block" style="margin-top: 0px;">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                    } else {
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
